import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Table, Sidenavbar, Dash_radialmenu } from "../../components";
import {
  radmenu,
  subjects,
  pt_me_subject_current,
} from "../../constants/dashboard";
import "./Dashboard.css";
import { Progressbar, Underline } from "../../widgets";
import { sidenav } from "../../constants/dashboard";
import { Alertmessage } from "../../widgets";
import Loader from "../../containers/Loader/Loader";

const Dash_results_ME = () => {
  const [sem_opt_flag, setSem_opt_flag] = useState(false);
  const [results, setResults] = useState([]);
  const [Cgpa, setCpga] = useState(0);
  const [sem_list, setSem_list] = useState([]);
  const [sem, setSem] = useState("");
  const [res_reg_no, setRes_reg_no] = useState("");
  const [res_stud_data, setRes_stud_data] = useState({});
  const [res_dept, setRes_dept] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [alertMessage, setAlertMessage] = useState("");
  const [disableMarksheet, setDisableMarksheet] = useState(false);
  const [showChangeEmailPhoneDialog, setShowChangeEmailPhoneDialog] =
    useState(false);
  const [email, setEmail] = useState("");
  const [emailStatus, setEmailStatus] = useState("");
  const [emailError, setEmailError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneStatus, setPhoneStatus] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    document.title = "ACCET-Student Results";
  }, []);
  useEffect(() => {
    setLoading(true);
    axios
      .get("/backend/dashboard_me")
      .then((res) => {
        // console.log(res.data);
        const mailid = res.data.stud_details?.mailid;
        const phoneno = res.data.stud_details?.phoneno;
        if (mailid === "TBD" || phoneno === "TBD") {
          setShowChangeEmailPhoneDialog(true);
        }
        handleDashboardData(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  const handleDashboardData = (data) => {
    if (data.Status === "Success") {
      setRes_reg_no(data.stud_details.regno);
      setRes_dept(data.stud_details.dept);
      setRes_stud_data(data.stud_details);
      // console.log("Success");
    }
  };

  useEffect(() => {
    // setLoading(true); // start loader
    axios
      .post("/backend/respublish_me")
      .then((res) => {
        if (res.data.Status === "Success") {
          // console.log(res.data);

          const res_pub = res.data.results;

          res_pub.map((item) => {
            // console.log(item);

            // item.subjectname = subjects[dept_sub][item.subcode].subname;
            item.subjectname = pt_me_subject_current[item.subcode].subname;
            return item; // Don't forget to return the modified item
          });
          // console.log(res_pub);
          // setSem(res_pub[0].sem);
          setResults(res_pub);
          // setRes_dept(result_dept);
          // setRes_reg_no(res.data.regno);
          // setRes_stud_data(res.data.stud_data);
          // get_sem_list(res.data.regno, result_dept);
          // setCpga(res.data.cgpa);
        } else {
          navigate("/login-page");
        }
      })
      .catch((err) => {
        // console.log(err);
        setAlertMessage("Your results have not yet been published.");
      })
      .finally(() => {
        setLoading(false); // stops loader no matter success or failure
      });

    // console.log(sem);
  }, [navigate]);

  const validateEmail = (value) => {
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value) {
      setEmailStatus("");
    } else if (emailRegex.test(value)) {
      setEmailStatus("Valid");
    } else {
      setEmailStatus("Invalid");
    }
  };
  const validatePhone = (value) => {
    setPhone(value);
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!value) {
      setPhoneStatus("");
    } else if (phoneRegex.test(value)) {
      setPhoneStatus("Valid");
    } else {
      setPhoneStatus("Invalid");
    }
  };
  const handleChangeEmailPhone = async () => {
    let valid = true;

    if (!email || emailStatus !== "Valid") {
      setEmailError("Enter valid email");
      valid = false;
    } else setEmailError("");

    if (!phone || phoneStatus !== "Valid") {
      setPhoneError("Enter valid phone number");
      valid = false;
    } else setPhoneError("");

    if (!valid) return;

    try {
      const res = await axios.post("/backend/update_email_phone", {
        regno: res_reg_no,
        email,
        phone,
      });

      if (res.data.Status === "Success") {
        setShowChangeEmailPhoneDialog(false);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Server error");
    }
  };

  const column = [
    // {field:'sno',header:"Sno"},
    // {field:'sem',header:"sem"},
    { field: "subcode", header: "subject code" },
    { field: "subjectname", header: "Subject Name" },
    { field: "grade", header: "Grade" },
    { field: "result", header: "Result" },
  ];
  const handleAlertMessage = () => {
    setAlertMessage("");
    // navigate("/results_me");
  };
  return (
    <div>
      <div className="dashboar-container">
        {loading && <Loader />}
        {showChangeEmailPhoneDialog && (
          <div className="password_dialog_outer">
            <div className="password_change_dialog">
              <h2>Update Email & Phone</h2>

              {/* EMAIL */}
              {emailStatus && (
                <div className="dashboard_pass_strength">
                  Email:&nbsp;
                  {emailStatus === "Valid" && (
                    <span className="password_str">Valid</span>
                  )}
                  {emailStatus === "Invalid" && (
                    <span className="password_weak">Invalid</span>
                  )}
                </div>
              )}
              {emailError && <div className="login_err_msg">{emailError}</div>}

              <div className="dashboard_form-control">
                <input
                  className="pswdbox"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                />
                <i className="fa fa-envelope"></i>
              </div>

              {/* PHONE */}
              {phoneStatus && (
                <div className="dashboard_pass_strength">
                  Phone:&nbsp;
                  {phoneStatus === "Valid" && (
                    <span className="password_str">Valid</span>
                  )}
                  {phoneStatus === "Invalid" && (
                    <span className="password_weak">Invalid</span>
                  )}
                </div>
              )}
              {phoneError && <div className="login_err_msg">{phoneError}</div>}

              <div className="dashboard_form-control">
                <input
                  className="pswdbox"
                  type="text"
                  placeholder="Enter your phone number"
                  value={phone}
                  onChange={(e) => validatePhone(e.target.value)}
                />
                <i className="fa fa-phone"></i>
              </div>

              <button
                className="pswdboxsubmit"
                onClick={handleChangeEmailPhone}
              >
                Submit
              </button>
            </div>
          </div>
        )}
        <div
          className="dash_complete_div"
          style={{ display: "flex", justifyContent: "center" }}
        >
          {/* <Sidenavbar links={sidenav} dash_state={1} /> */}
          {/* <Dash_radialmenu menu_links={radmenu} /> */}

          <div className="profile-sec">
            <div className="dash-result">
              <div>
                <h1>ME RESULTS</h1>
                <div className="dash-result-head">
                  <Underline heading={"Result"} />
                  <div className="dash-personal">
                    <div className="dash-res1">
                      <p className="dash-personal1">
                        <div className="dash-head">Name:</div>{" "}
                        {res_stud_data.studentname}
                      </p>
                      <p className="dash-personal1">
                        <div className="dash-head">Register number:</div>
                        {res_reg_no}
                      </p>
                    </div>
                    <div className="dash-res2">
                      <p className="dash-personal2">
                        <div className="dash-head">Batch:</div>
                        {res_stud_data.batch}
                      </p>
                      <p className="dash-personal2">
                        <div className="dash-head">Department:</div>
                        {res_dept}
                      </p>
                    </div>
                    {/* <div className="dash-res3">
                      <p className="dash-personal3">
                        <div className="dash-head">CGPA:</div>
                        {Cgpa}
                      </p>
                    </div> */}
                  </div>
                </div>
                <div className="dash-result-table">
                  <div className="dash-table-header">
                    {/* <div className="sem_options_holder">
                      
                        <div
                          className="sem_input_holder"
                          tabIndex={0}
                          onFocus={(e) => setSem_opt_flag(true)}
                          onBlur={(e) => setSem_opt_flag(false)}
                        >
                          <div className="sem_input">Sem {sem}</div>
                          <div className="fa fa fa-chevron-circle-down"></div>
                        </div>
                      
                      
                        <div className="sem_options">
                          {sem_opt_flag &&
                            sem_list.map((item) => (
                              <div
                                className="sem_dropdown"
                                onMouseDown={(e) => {
                                  fetch_all_results(res_reg_no, res_dept, item);
                                }}
                              >
                                Sem {item}
                              </div>
                            ))}
                        </div>
                      
                    </div>
                    <div className="dash-result-table-head">Semester {sem}
                    </div> */}
                  </div>
                  <div className="dash_res_table_holder">
                    <Table data={results} columns={column} />
                  </div>
                  {/* {
                    <div className="marksheet-container">
                      <div className="cool_holder">
                        <button
                          onClick={download_marksheet}
                          className="coolass_button"
                          id="coolbutton"
                          disabled={disableMarksheet}
                        ></button>
                      </div>
                    </div>
                  } */}
                  <div className="dash-tbd">
                    <p className="dash-note">Note : </p>
                    <p>TBD - To be displayed</p>
                  </div>
                  <div className="logout_button logout-btn">
                    <a className="log_link" href="/logout">
                      Logout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Alertmessage message={alertMessage} onClose={handleAlertMessage} />
    </div>
  );
};

export default Dash_results_ME;
